
(function(){
  var $ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };
  var suave = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  /* Experiencias: filtro por lugar */
  $('.donde button').forEach(function(b){
    b.addEventListener('click', function(){
      $('.donde button').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var l = b.getAttribute('data-lugar');
      $('.exp').forEach(function(e){ var el = e.getAttribute('data-lugar'); e.hidden = !(l === 'todas' || el === l || el === 'ambos'); });
    });
  });

  /* Experiencias: "Me interesa" sincronizado con el formulario */
  var marcas = {};
  $('#marcas input').forEach(function(i){ marcas[i.value] = i; });
  var fija = document.getElementById('fija-cotizar');
  function contar(){ var n = $('#marcas input:checked').length; fija.textContent = n ? 'Cotizar (' + n + ')' : 'Cotizar'; }
  function pintar(valor, on){
    $('.exp').forEach(function(e){
      if(e.getAttribute('data-valor') === valor){ e.classList.toggle('elegida', on); e.querySelector('.toggle').setAttribute('aria-pressed', on ? 'true' : 'false'); }
    });
  }
  $('.exp').forEach(function(e){
    e.querySelector('.toggle').addEventListener('click', function(){
      var v = e.getAttribute('data-valor'), on = this.getAttribute('aria-pressed') !== 'true';
      if(marcas[v]) marcas[v].checked = on;
      pintar(v, on); contar();
    });
  });
  $('#marcas input').forEach(function(i){ i.addEventListener('change', function(){ pintar(i.value, i.checked); contar(); }); });

  /* Sedes: filtros */
  var estado = {min:0, rango:'', zona:'todas', extras:[]};
  var cards = $('.sede'), resultado = document.getElementById('resultado'), vacio = document.getElementById('vacio');
  function filtrar(){
    var n = 0;
    cards.forEach(function(c){
      var ex = c.getAttribute('data-extras').split(' ');
      var ok = +c.getAttribute('data-cap') >= estado.min &&
               (estado.zona === 'todas' || c.getAttribute('data-zona') === estado.zona) &&
               estado.extras.every(function(e){ return ex.indexOf(e) > -1; });
      c.hidden = !ok; if(ok) n++;
    });
    vacio.hidden = n > 0;
    resultado.textContent = n === cards.length ? 'Las ' + cards.length + ' sedes' : n === 1 ? '1 sede para tu equipo' : n + ' sedes para tu equipo';
  }
  function grupo(sel, fn){
    var bs = $(sel);
    bs.forEach(function(b){ b.addEventListener('click', function(){ bs.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); fn(b); filtrar(); }); });
  }
  grupo('[data-min]', function(b){ estado.min = +b.getAttribute('data-min'); estado.rango = b.getAttribute('data-rango') || ''; });
  grupo('[data-zona]', function(b){ estado.zona = b.getAttribute('data-zona'); });
  $('[data-extra]').forEach(function(b){
    b.addEventListener('click', function(){
      var e = b.getAttribute('data-extra'), on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      estado.extras = on ? estado.extras.concat(e) : estado.extras.filter(function(x){ return x !== e; });
      filtrar();
    });
  });

  /* Cuántas experiencias lleva elegidas (debajo del paso 2) */
  var cuenta = document.getElementById('cuenta-elegidas');
  function textoCuenta(){ var n = $('#marcas input:checked').length; cuenta.textContent = n === 0 ? 'Aún no has elegido opciones. Puedes seguir sin elegir.' : n === 1 ? 'Llevas 1 opción elegida.' : 'Llevas ' + n + ' opciones elegidas.'; }
  $('.exp .toggle, #marcas input').forEach(function(el){ el.addEventListener(el.tagName === 'INPUT' ? 'change' : 'click', function(){ setTimeout(textoCuenta, 0); }); });

  /* Paso 3: en un pub o en tu empresa */
  var paneles = {pub: document.getElementById('panel-pub'), empresa: document.getElementById('panel-empresa')};
  $('.opcion').forEach(function(b){
    b.addEventListener('click', function(){
      $('.opcion').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var k = b.getAttribute('data-panel');
      paneles.pub.hidden = k !== 'pub'; paneles.empresa.hidden = k !== 'empresa';
    });
  });

  /* "Cotizar aquí": llena el formulario y baja */
  var fSede = document.getElementById('f-sede'), fPers = document.getElementById('f-personas');
  function marcar(el){ el.classList.add('lleno'); setTimeout(function(){ el.classList.remove('lleno'); }, 2400); }
  document.getElementById('cotizar-empresa').addEventListener('click', function(){
    fSede.value = 'En nuestra empresa'; marcar(fSede);
    document.getElementById('cotizar').scrollIntoView({behavior:suave});
    setTimeout(function(){ document.getElementById('f-empresa').focus({preventScroll:true}); }, 600);
  });
  cards.forEach(function(c){
    c.querySelector('.elegir').addEventListener('click', function(){
      fSede.value = c.getAttribute('data-nombre'); marcar(fSede);
      if(estado.rango){ fPers.value = estado.rango; marcar(fPers); }
      document.getElementById('cotizar').scrollIntoView({behavior:suave});
      setTimeout(function(){ document.getElementById('f-empresa').focus({preventScroll:true}); }, 600);
    });
  });

  /* Videos: arrancan sin sonido cuando se ven; el botón los reinicia con sonido */
  var sinMov = matchMedia('(prefers-reduced-motion: reduce)').matches;
  $('.video-wrap').forEach(function(w){
    var v = w.querySelector('video'), b = w.querySelector('.sonido');
    v.muted = true;
    function reproducir(){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
    if(!sinMov && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ if(v.muted) reproducir(); } else { v.pause(); } }); }, {threshold:.5}).observe(v);
    }
    b.addEventListener('click', function(){
      $('.video-wrap video').forEach(function(o){ if(o !== v){ o.pause(); } });
      v.muted = false; v.loop = false; v.currentTime = 0; v.controls = true; reproducir(); b.hidden = true;
    });
  });

  /* Urgencia real: días que faltan para diciembre (luego, para Navidad) */
  (function(){
    var hoy = new Date(); hoy.setHours(0,0,0,0);
    var y = hoy.getFullYear(), dic = new Date(y,11,1), nav = new Date(y,11,24);
    var dias = function(a){ return Math.round((a - hoy) / 864e5); }, t = '';
    if(hoy < dic){ var n = dias(dic); t = n === 1 ? 'Diciembre empieza mañana' : 'Diciembre empieza en ' + n + ' días'; }
    else if(hoy <= nav){ var m = dias(nav); t = m === 0 ? 'Hoy es Nochebuena' : 'Faltan ' + m + ' días para Navidad'; }
    $('.urgencia').forEach(function(u){ if(t){ u.querySelector('.txt').textContent = t + ' · Separa tu fecha'; } else { u.hidden = true; } });
  })();

  /* Indicador de pasos: marca el paso en el que va la persona */
  var links = $('.pasosnav a'), orden = links.map(function(a){ return a.getAttribute('data-paso'); });
  function marcarPaso(id){
    var i = orden.indexOf(id);
    links.forEach(function(a, j){
      if(j === i){ a.setAttribute('aria-current', 'step'); } else { a.removeAttribute('aria-current'); }
      a.classList.toggle('hecho', j < i);
    });
  }
  marcarPaso('info');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) marcarPaso(e.target.id); }); }, {rootMargin:'-40% 0px -55% 0px'});
    orden.forEach(function(id){ var el = document.getElementById(id); if(el) io.observe(el); });
  }
})();

/* Shopify: une las experiencias en un solo campo, guarda datos para WhatsApp y marca Lead */
(function(){
  var f=document.getElementById('cotizar-form'); if(!f) return;
  f.addEventListener('submit',function(){
    var v=[].slice.call(f.querySelectorAll('#marcas input:checked')).map(function(i){return i.value;}).join(', ');
    document.getElementById('f-intereses').value=v||'Ninguna';
    try{ sessionStorage.setItem('irishCot', JSON.stringify({
      empresa:f.querySelector('#f-empresa').value, personas:f.querySelector('#f-personas').value,
      sede:f.querySelector('#f-sede').value, fecha:f.querySelector('#f-fecha').value,
      horario:f.querySelector('#f-horario').value, intereses:v })); }catch(e){}
    try{ if(window.fbq) fbq('track','Lead',{content_name:'Fiestas empresas'}); }catch(e){}
  });
})();
(function(){
  var b=document.getElementById('wa-gracias'); if(!b) return;
  var d={}; try{ d=JSON.parse(sessionStorage.getItem('irishCot')||'{}'); }catch(e){}
  var t='Hola, acabo de pedir cotización para la fiesta de fin de año de '+(d.empresa||'mi empresa')+
    (d.personas?'. Somos '+d.personas+' personas':'')+(d.sede?', lugar: '+d.sede:'')+
    (d.fecha?', fecha: '+d.fecha:'')+(d.horario?' ('+d.horario+')':'')+(d.intereses?'. Nos interesa: '+d.intereses:'')+'.';
  b.href='https://wa.me/573053936650?text='+encodeURIComponent(t);
  var c=document.getElementById('cotizar'); if(c) c.scrollIntoView();
})();
